import React from 'react';

export const TemplateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <rect width="56" height="26" rx="8" fill="#2364EB" />
    <rect y="30" width="56" height="26" rx="8" opacity="0.4" fill="#2364EB" />
    <path
      d="M9.57031 17.0625C9.57031 16.7708 9.66927 16.526 9.86719 16.3281C10.0651 16.125 10.3333 16.0234 10.6719 16.0234C11.0156 16.0234 11.2839 16.125 11.4766 16.3281C11.6745 16.526 11.7734 16.7708 11.7734 17.0625C11.7734 17.3542 11.6745 17.599 11.4766 17.7969C11.2839 17.9948 11.0156 18.0938 10.6719 18.0938C10.3333 18.0938 10.0651 17.9948 9.86719 17.7969C9.66927 17.599 9.57031 17.3542 9.57031 17.0625ZM19.1016 16.25V6H20.9922V18H19.2812L19.1016 16.25ZM13.6016 13.8672V13.7031C13.6016 13.0625 13.6771 12.4792 13.8281 11.9531C13.9792 11.4219 14.1979 10.9661 14.4844 10.5859C14.7708 10.2005 15.1198 9.90625 15.5312 9.70312C15.9427 9.49479 16.4062 9.39062 16.9219 9.39062C17.4323 9.39062 17.8802 9.48958 18.2656 9.6875C18.651 9.88542 18.9792 10.1693 19.25 10.5391C19.5208 10.9036 19.737 11.3411 19.8984 11.8516C20.0599 12.3568 20.1745 12.9193 20.2422 13.5391V14.0625C20.1745 14.6667 20.0599 15.2188 19.8984 15.7188C19.737 16.2188 19.5208 16.651 19.25 17.0156C18.9792 17.3802 18.6484 17.6615 18.2578 17.8594C17.8724 18.0573 17.4219 18.1562 16.9062 18.1562C16.3958 18.1562 15.9349 18.0495 15.5234 17.8359C15.1172 17.6224 14.7708 17.3229 14.4844 16.9375C14.1979 16.5521 13.9792 16.099 13.8281 15.5781C13.6771 15.0521 13.6016 14.4818 13.6016 13.8672ZM15.4844 13.7031V13.8672C15.4844 14.2526 15.5182 14.612 15.5859 14.9453C15.6589 15.2786 15.7708 15.5729 15.9219 15.8281C16.0729 16.0781 16.2682 16.276 16.5078 16.4219C16.7526 16.5625 17.0443 16.6328 17.3828 16.6328C17.8099 16.6328 18.1615 16.5391 18.4375 16.3516C18.7135 16.1641 18.9297 15.9115 19.0859 15.5938C19.2474 15.2708 19.3568 14.9115 19.4141 14.5156V13.1016C19.3828 12.7943 19.3177 12.5078 19.2188 12.2422C19.125 11.9766 18.9974 11.7448 18.8359 11.5469C18.6745 11.3438 18.474 11.1875 18.2344 11.0781C18 10.9635 17.7214 10.9062 17.3984 10.9062C17.0547 10.9062 16.763 10.9792 16.5234 11.125C16.2839 11.2708 16.0859 11.4714 15.9297 11.7266C15.7786 11.9818 15.6667 12.2786 15.5938 12.6172C15.5208 12.9557 15.4844 13.3177 15.4844 13.7031ZM22.6016 13.8672V13.6875C22.6016 13.0781 22.6901 12.513 22.8672 11.9922C23.0443 11.4661 23.2995 11.0104 23.6328 10.625C23.9714 10.2344 24.3828 9.93229 24.8672 9.71875C25.3568 9.5 25.9089 9.39062 26.5234 9.39062C27.1432 9.39062 27.6953 9.5 28.1797 9.71875C28.6693 9.93229 29.0833 10.2344 29.4219 10.625C29.7604 11.0104 30.0182 11.4661 30.1953 11.9922C30.3724 12.513 30.4609 13.0781 30.4609 13.6875V13.8672C30.4609 14.4766 30.3724 15.0417 30.1953 15.5625C30.0182 16.0833 29.7604 16.5391 29.4219 16.9297C29.0833 17.3151 28.6719 17.6172 28.1875 17.8359C27.7031 18.0495 27.1536 18.1562 26.5391 18.1562C25.9193 18.1562 25.3646 18.0495 24.875 17.8359C24.3906 17.6172 23.9792 17.3151 23.6406 16.9297C23.3021 16.5391 23.0443 16.0833 22.8672 15.5625C22.6901 15.0417 22.6016 14.4766 22.6016 13.8672ZM24.4844 13.6875V13.8672C24.4844 14.2474 24.5234 14.6068 24.6016 14.9453C24.6797 15.2839 24.8021 15.5807 24.9688 15.8359C25.1354 16.0911 25.349 16.2917 25.6094 16.4375C25.8698 16.5833 26.1797 16.6562 26.5391 16.6562C26.888 16.6562 27.1901 16.5833 27.4453 16.4375C27.7057 16.2917 27.9193 16.0911 28.0859 15.8359C28.2526 15.5807 28.375 15.2839 28.4531 14.9453C28.5365 14.6068 28.5781 14.2474 28.5781 13.8672V13.6875C28.5781 13.3125 28.5365 12.9583 28.4531 12.625C28.375 12.2865 28.25 11.987 28.0781 11.7266C27.9115 11.4661 27.6979 11.263 27.4375 11.1172C27.1823 10.9661 26.8776 10.8906 26.5234 10.8906C26.1693 10.8906 25.862 10.9661 25.6016 11.1172C25.3464 11.263 25.1354 11.4661 24.9688 11.7266C24.8021 11.987 24.6797 12.2865 24.6016 12.625C24.5234 12.9583 24.4844 13.3125 24.4844 13.6875ZM35.4922 16.6562C35.7995 16.6562 36.0755 16.5964 36.3203 16.4766C36.5703 16.3516 36.7708 16.1797 36.9219 15.9609C37.0781 15.7422 37.1641 15.4896 37.1797 15.2031H38.9531C38.9427 15.75 38.7812 16.2474 38.4688 16.6953C38.1562 17.1432 37.7422 17.5 37.2266 17.7656C36.7109 18.026 36.1406 18.1562 35.5156 18.1562C34.8698 18.1562 34.3073 18.0469 33.8281 17.8281C33.349 17.6042 32.9505 17.2969 32.6328 16.9062C32.3151 16.5156 32.0755 16.0651 31.9141 15.5547C31.7578 15.0443 31.6797 14.4974 31.6797 13.9141V13.6406C31.6797 13.0573 31.7578 12.5104 31.9141 12C32.0755 11.4844 32.3151 11.0312 32.6328 10.6406C32.9505 10.25 33.349 9.94531 33.8281 9.72656C34.3073 9.5026 34.8672 9.39062 35.5078 9.39062C36.1849 9.39062 36.7786 9.52604 37.2891 9.79688C37.7995 10.0625 38.2005 10.4349 38.4922 10.9141C38.7891 11.388 38.9427 11.9401 38.9531 12.5703H37.1797C37.1641 12.2578 37.0859 11.9766 36.9453 11.7266C36.8099 11.4714 36.6172 11.2682 36.3672 11.1172C36.1224 10.9661 35.8281 10.8906 35.4844 10.8906C35.1042 10.8906 34.7891 10.9688 34.5391 11.125C34.2891 11.276 34.0938 11.4844 33.9531 11.75C33.8125 12.0104 33.7109 12.3047 33.6484 12.6328C33.5911 12.9557 33.5625 13.2917 33.5625 13.6406V13.9141C33.5625 14.263 33.5911 14.6016 33.6484 14.9297C33.7057 15.2578 33.8047 15.5521 33.9453 15.8125C34.0911 16.0677 34.2891 16.2734 34.5391 16.4297C34.7891 16.5807 35.1068 16.6562 35.4922 16.6562ZM41.8359 9.54688L43.4453 12.3516L45.0859 9.54688H47.1562L44.5938 13.6953L47.2578 18H45.1875L43.4688 15.0781L41.75 18H39.6719L42.3281 13.6953L39.7734 9.54688H41.8359Z"
      fill="white"
    />
    <path
      d="M14.9844 47.0625C14.9844 46.7708 15.0833 46.526 15.2812 46.3281C15.4792 46.125 15.7474 46.0234 16.0859 46.0234C16.4297 46.0234 16.6979 46.125 16.8906 46.3281C17.0885 46.526 17.1875 46.7708 17.1875 47.0625C17.1875 47.3542 17.0885 47.599 16.8906 47.7969C16.6979 47.9948 16.4297 48.0938 16.0859 48.0938C15.7474 48.0938 15.4792 47.9948 15.2812 47.7969C15.0833 47.599 14.9844 47.3542 14.9844 47.0625ZM21.25 41.1719V51.25H19.3672V39.5469H21.1016L21.25 41.1719ZM26.7578 43.6953V43.8594C26.7578 44.474 26.6849 45.0443 26.5391 45.5703C26.3984 46.0911 26.1875 46.5469 25.9062 46.9375C25.6302 47.3229 25.2891 47.6224 24.8828 47.8359C24.4766 48.0495 24.0078 48.1562 23.4766 48.1562C22.9505 48.1562 22.4896 48.0599 22.0938 47.8672C21.7031 47.6693 21.3724 47.3906 21.1016 47.0312C20.8307 46.6719 20.612 46.25 20.4453 45.7656C20.2839 45.276 20.1693 44.7396 20.1016 44.1562V43.5234C20.1693 42.9036 20.2839 42.3411 20.4453 41.8359C20.612 41.3307 20.8307 40.8958 21.1016 40.5312C21.3724 40.1667 21.7031 39.8854 22.0938 39.6875C22.4844 39.4896 22.9401 39.3906 23.4609 39.3906C23.9922 39.3906 24.4635 39.4948 24.875 39.7031C25.2865 39.9062 25.6328 40.1979 25.9141 40.5781C26.1953 40.9531 26.4062 41.4062 26.5469 41.9375C26.6875 42.4635 26.7578 43.0495 26.7578 43.6953ZM24.875 43.8594V43.6953C24.875 43.3047 24.8385 42.9427 24.7656 42.6094C24.6927 42.2708 24.5781 41.974 24.4219 41.7188C24.2656 41.4635 24.0651 41.2656 23.8203 41.125C23.5807 40.9792 23.2917 40.9062 22.9531 40.9062C22.6198 40.9062 22.3333 40.9635 22.0938 41.0781C21.8542 41.1875 21.6536 41.3411 21.4922 41.5391C21.3307 41.737 21.2057 41.9688 21.1172 42.2344C21.0286 42.4948 20.9661 42.7786 20.9297 43.0859V44.6016C20.9922 44.9766 21.099 45.3203 21.25 45.6328C21.401 45.9453 21.6146 46.1953 21.8906 46.3828C22.1719 46.5651 22.5312 46.6562 22.9688 46.6562C23.3073 46.6562 23.5964 46.5833 23.8359 46.4375C24.0755 46.2917 24.2708 46.0911 24.4219 45.8359C24.5781 45.5755 24.6927 45.276 24.7656 44.9375C24.8385 44.599 24.875 44.2396 24.875 43.8594ZM33.5156 46.25V36H35.4062V48H33.6953L33.5156 46.25ZM28.0156 43.8672V43.7031C28.0156 43.0625 28.0911 42.4792 28.2422 41.9531C28.3932 41.4219 28.612 40.9661 28.8984 40.5859C29.1849 40.2005 29.5339 39.9062 29.9453 39.7031C30.3568 39.4948 30.8203 39.3906 31.3359 39.3906C31.8464 39.3906 32.2943 39.4896 32.6797 39.6875C33.0651 39.8854 33.3932 40.1693 33.6641 40.5391C33.9349 40.9036 34.151 41.3411 34.3125 41.8516C34.474 42.3568 34.5885 42.9193 34.6562 43.5391V44.0625C34.5885 44.6667 34.474 45.2188 34.3125 45.7188C34.151 46.2188 33.9349 46.651 33.6641 47.0156C33.3932 47.3802 33.0625 47.6615 32.6719 47.8594C32.2865 48.0573 31.8359 48.1562 31.3203 48.1562C30.8099 48.1562 30.349 48.0495 29.9375 47.8359C29.5312 47.6224 29.1849 47.3229 28.8984 46.9375C28.612 46.5521 28.3932 46.099 28.2422 45.5781C28.0911 45.0521 28.0156 44.4818 28.0156 43.8672ZM29.8984 43.7031V43.8672C29.8984 44.2526 29.9323 44.612 30 44.9453C30.0729 45.2786 30.1849 45.5729 30.3359 45.8281C30.487 46.0781 30.6823 46.276 30.9219 46.4219C31.1667 46.5625 31.4583 46.6328 31.7969 46.6328C32.224 46.6328 32.5755 46.5391 32.8516 46.3516C33.1276 46.1641 33.3438 45.9115 33.5 45.5938C33.6615 45.2708 33.7708 44.9115 33.8281 44.5156V43.1016C33.7969 42.7943 33.7318 42.5078 33.6328 42.2422C33.5391 41.9766 33.4115 41.7448 33.25 41.5469C33.0885 41.3438 32.888 41.1875 32.6484 41.0781C32.4141 40.9635 32.1354 40.9062 31.8125 40.9062C31.4688 40.9062 31.1771 40.9792 30.9375 41.125C30.6979 41.2708 30.5 41.4714 30.3438 41.7266C30.1927 41.9818 30.0807 42.2786 30.0078 42.6172C29.9349 42.9557 29.8984 43.3177 29.8984 43.7031ZM39.9219 48H38.0391V38.7344C38.0391 38.1042 38.1562 37.5755 38.3906 37.1484C38.6302 36.7161 38.9714 36.3906 39.4141 36.1719C39.8568 35.9479 40.3802 35.8359 40.9844 35.8359C41.1719 35.8359 41.3568 35.849 41.5391 35.875C41.7214 35.8958 41.8984 35.9297 42.0703 35.9766L42.0234 37.4297C41.9193 37.4036 41.8047 37.3854 41.6797 37.375C41.5599 37.3646 41.4297 37.3594 41.2891 37.3594C41.0026 37.3594 40.7552 37.4141 40.5469 37.5234C40.3438 37.6276 40.1875 37.7812 40.0781 37.9844C39.974 38.1875 39.9219 38.4375 39.9219 38.7344V48ZM41.6641 39.5469V40.9219H36.7422V39.5469H41.6641Z"
      fill="#2364EB"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 57.1992C38 56.0946 38.8954 55.1992 40 55.1992L56 55.1992C57.1046 55.1992 58 56.0946 58 57.1992C58 58.3038 57.1046 59.1992 56 59.1992L40 59.1992C38.8954 59.1992 38 58.3038 38 57.1992Z"
      fill="#2364EB"
    />
    <path
      d="M36.4458 9.61297L37.5246 8.5342C42.4712 3.58756 50.4913 3.58756 55.4379 8.5342C60.3846 13.4808 60.3846 21.5009 55.4379 26.4476L54.3592 27.5263L36.4458 9.61297Z"
      fill="#2364EB"
    />
    <path
      opacity="0.4"
      d="M33.6174 12.4414L13.1473 32.9115C10.8881 35.1707 9.75854 36.3003 8.85468 37.5695C7.60355 39.3263 6.66634 41.2867 6.08467 43.3635C5.66445 44.8639 5.49462 46.4523 5.15495 49.629C4.82529 52.7122 4.66043 54.2541 5.06532 55.4318C5.62638 57.0637 6.9085 58.3458 8.54045 58.9069C9.71816 59.3118 11.2598 59.147 14.343 58.8173C17.5197 58.4776 19.1083 58.3078 20.6087 57.8875C22.6856 57.3059 24.6459 56.3687 26.4027 55.1175C27.6719 54.2137 28.8015 53.0841 31.0606 50.825L51.5308 30.3548L33.6174 12.4414Z"
      fill="#2364EB"
    />
  </svg>
);

export const MedalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5808_7194)">
      <path
        opacity="0.4"
        d="M13.3333 39.9987C13.3333 50.308 21.6906 58.6654 31.9999 58.6654C42.3092 58.6654 50.6666 50.308 50.6666 39.9987C50.6666 29.6894 42.3092 21.332 31.9999 21.332C21.6906 21.332 13.3333 29.6894 13.3333 39.9987Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.3847 32.9667C34.9744 33.3311 35.3333 33.9748 35.3333 34.668V45.3346C35.3333 46.4392 34.4379 47.3346 33.3333 47.3346C32.2287 47.3346 31.3333 46.4392 31.3333 45.3346V37.904L28.8944 39.1235C27.9064 39.6175 26.7051 39.217 26.2111 38.2291C25.7171 37.2411 26.1176 36.0398 27.1055 35.5458L32.4389 32.8791C33.0588 32.5691 33.7951 32.6023 34.3847 32.9667Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3605 5.00355C11.5421 3.914 12.5726 3.17797 13.6621 3.35956C22.2483 4.79059 30.9994 10.5502 33.923 20.7829C34.2265 21.845 33.6115 22.9519 32.5494 23.2554C31.4874 23.5588 30.3804 22.9439 30.0769 21.8818C27.6672 13.4478 20.4183 8.54076 13.0045 7.30513C11.915 7.12354 11.1789 6.09309 11.3605 5.00355Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.36449 12.9808C3.55867 11.8934 4.59756 11.1693 5.68493 11.3635C10.4794 12.2197 14.6752 13.5352 18.1128 15.8372C21.598 18.1711 24.1829 21.4372 25.8737 25.9662C26.26 27.001 25.7343 28.1531 24.6995 28.5394C23.6647 28.9257 22.5127 28.4 22.1263 27.3652C20.706 23.5608 18.6242 20.9937 15.8872 19.1609C13.1026 17.2962 9.52061 16.1117 4.98177 15.3012C3.8944 15.1071 3.17032 14.0682 3.36449 12.9808Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.6355 12.9808C60.4413 11.8934 59.4024 11.1693 58.3151 11.3635C53.5206 12.2197 49.3248 13.5352 45.8872 15.8372C42.402 18.1711 39.8171 21.4372 38.1263 25.9662C37.74 27.001 38.2657 28.1531 39.3005 28.5394C40.3353 28.9257 41.4873 28.4 41.8737 27.3652C43.294 23.5608 45.3758 20.9937 48.1128 19.1609C50.8974 17.2962 54.4794 16.1117 59.0182 15.3012C60.1056 15.1071 60.8297 14.0682 60.6355 12.9808Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.6395 5.00355C52.8211 6.09309 52.085 7.12354 50.9955 7.30513C43.5817 8.54076 36.3328 13.4478 33.9231 21.8818C33.6196 22.9439 32.5127 23.5588 31.4506 23.2554C30.3885 22.9519 29.7735 21.845 30.077 20.7829C33.0006 10.5502 41.7517 4.79059 50.3379 3.35956C51.4274 3.17797 52.4579 3.914 52.6395 5.00355Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5808_7194">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BulbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5808_7121)">
      <path
        opacity="0.4"
        d="M10.6667 26.6654V27.3548C10.6667 32.0191 12.5973 36.4753 16.0001 39.6654L19.0446 42.5196C20.0601 43.4716 20.77 44.6864 21.1084 46.0112C21.1822 46.003 21.2573 45.9987 21.3334 45.9987H30.0001L30.0001 33.6107C29.5313 33.4289 29.0819 33.1914 28.6494 32.916L25.6123 31.0315C24.6737 30.4491 24.3849 29.2161 24.9673 28.2775C25.5497 27.339 26.7827 27.0502 27.7212 27.6326L30.7911 29.5374C31.3934 29.9222 31.7596 29.9987 32.0001 29.9987C32.2405 29.9987 32.6069 29.9223 33.2092 29.5376L33.2312 29.5235L36.2789 27.6326C37.2175 27.0502 38.4505 27.339 39.0328 28.2775C39.6152 29.2161 39.3265 30.4491 38.3879 31.0315L35.3507 32.916C34.9182 33.1914 34.4688 33.4289 34.0001 33.6107V45.9987H42.6667C42.7428 45.9987 42.8179 46.003 42.8918 46.0112C43.2301 44.6864 43.9401 43.4716 44.9556 42.5196L48.0001 39.6654C51.4028 36.4753 53.3334 32.0191 53.3334 27.3548V26.6654C53.3334 14.8833 43.7822 5.33203 32.0001 5.33203C20.218 5.33203 10.6667 14.8833 10.6667 26.6654Z"
        fill="#2364EB"
      />
      <path
        d="M42.4795 50C41.5433 54.9351 37.2074 58.6667 32 58.6667C26.7925 58.6667 22.4567 54.9351 21.5205 50H42.4795Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5808_7121">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DocIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5808_7113)">
      <path
        opacity="0.4"
        d="M8.66675 26.6654C8.66675 20.4611 8.66675 17.359 9.48247 14.8484C11.1311 9.77445 15.1092 5.79639 20.1831 4.14776C22.6937 3.33203 25.7958 3.33203 32.0001 3.33203C38.2044 3.33203 41.3065 3.33203 43.817 4.14776C48.891 5.79639 52.8691 9.77445 54.5177 14.8484C55.3334 17.359 55.3334 20.4611 55.3334 26.6654V37.332C55.3334 43.5363 55.3334 46.6384 54.5177 49.149C52.8691 54.2229 48.891 58.201 43.817 59.8496C41.3065 60.6654 38.2044 60.6654 32.0001 60.6654C25.7958 60.6654 22.6937 60.6654 20.1831 59.8496C15.1092 58.201 11.1311 54.2229 9.48247 49.149C8.66675 46.6384 8.66675 43.5363 8.66675 37.332V26.6654Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 32C22 30.8954 22.8954 30 24 30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H24C22.8954 34 22 33.1046 22 32Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 21.332C22 20.2275 22.8954 19.332 24 19.332H40C41.1046 19.332 42 20.2275 42 21.332C42 22.4366 41.1046 23.332 40 23.332H24C22.8954 23.332 22 22.4366 22 21.332Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 42.668C22 41.5634 22.8954 40.668 24 40.668H34.6665C35.771 40.668 36.6665 41.5634 36.6665 42.668C36.6665 43.7725 35.771 44.668 34.6665 44.668H24C22.8954 44.668 22 43.7725 22 42.668Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5808_7113">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SkillsIcon = ({ width = 64, height = 64 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_6050_2133)">
      <path
        opacity="0.4"
        d="M13.25 4.75C13.25 2.817 14.817 1.25 16.75 1.25H19.25C21.183 1.25 22.75 2.817 22.75 4.75V7.25C22.75 9.183 21.183 10.75 19.25 10.75H16.75C14.817 10.75 13.25 9.183 13.25 7.25V4.75Z"
        fill="#2364EB"
      />
      <path
        opacity="0.4"
        d="M13.25 16.75C13.25 14.817 14.817 13.25 16.75 13.25H19.25C21.183 13.25 22.75 14.817 22.75 16.75V19.25C22.75 21.183 21.183 22.75 19.25 22.75H16.75C14.817 22.75 13.25 21.183 13.25 19.25V16.75Z"
        fill="#2364EB"
      />
      <path
        d="M1.25 5C1.25 2.92893 2.92893 1.25 5 1.25H7C9.07107 1.25 10.75 2.92893 10.75 5V19C10.75 21.0711 9.07107 22.75 7 22.75H5C2.92893 22.75 1.25 21.0711 1.25 19V5Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_6050_2133">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SkillMatchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5825_7835)">
      <path
        d="M30.0002 3.33594C22.6168 3.34398 18.6821 3.44479 15.5108 4.70836C10.5787 6.6735 6.67175 10.5804 4.70661 15.5126C3.3335 18.9588 3.3335 23.3065 3.3335 32.0019C3.3335 40.6973 3.3335 45.045 4.70661 48.4912C6.67175 53.4234 10.5787 57.3303 15.5108 59.2955C18.6821 60.559 22.6168 60.6598 30.0002 60.6679L30.0002 3.33594Z"
        fill="#2364EB"
      />
      <path
        opacity="0.4"
        d="M34 60.6679C41.3834 60.6598 45.318 60.559 48.4893 59.2955C53.4215 57.3303 57.3284 53.4234 59.2935 48.4912C60.6667 45.045 60.6667 40.6973 60.6667 32.0019C60.6667 23.3065 60.6667 18.9588 59.2935 15.5126C57.3284 10.5804 53.4215 6.6735 48.4893 4.70836C45.318 3.44479 41.3834 3.34398 34 3.33594L34 60.6679Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5825_7835">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5825_7741)">
      <path
        opacity="0.4"
        d="M46.8981 59.3346H17.102C6.59777 59.3346 -0.149454 48.1778 4.7288 38.8751L18.3322 12.9338C20.9971 7.85176 26.2617 4.66797 32 4.66797C37.7384 4.66797 43.0029 7.85176 45.6679 12.9337L59.2713 38.8751C64.1495 48.1778 57.4023 59.3346 46.8981 59.3346Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 20C33.1046 20 34 20.8954 34 22L34 30C34 31.1046 33.1046 32 32 32C30.8954 32 30 31.1046 30 30L30 22C30 20.8954 30.8954 20 32 20Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0002 44.668C30.5274 44.668 29.3335 43.4741 29.3335 42.0013L29.3335 41.9986C29.3335 40.5259 30.5274 39.332 32.0002 39.332C33.4729 39.332 34.6668 40.5259 34.6668 41.9986L34.6668 42.0013C34.6668 43.4741 33.4729 44.668 32.0002 44.668Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5825_7741">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BriefcaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5825_7748)">
      <path
        opacity="0.4"
        d="M40.6668 44.6664V45.3331C40.6668 46.4376 41.5623 47.3331 42.6668 47.3331C43.7714 47.3331 44.6668 46.4376 44.6668 45.3331V44.6664H45.3335C52.2222 44.6664 57.05 43.2957 60.2002 40.9331C60.3586 40.8142 60.5123 40.6932 60.6613 40.5703C60.6371 44.7024 60.511 47.1197 59.8513 49.15C58.2026 54.224 54.2246 58.202 49.1506 59.8507C46.6401 60.6664 43.5379 60.6664 37.3336 60.6664H26.667C20.4627 60.6664 17.3606 60.6664 14.85 59.8507C9.77606 58.202 5.798 54.224 4.14937 49.15C3.48969 47.1197 3.3635 44.7025 3.33936 40.5706C3.48822 40.6934 3.64179 40.8143 3.80015 40.9331C6.95035 43.2957 11.7782 44.6664 18.6668 44.6664H19.3335V45.3331C19.3335 46.4376 20.2289 47.3331 21.3335 47.3331C22.4381 47.3331 23.3335 46.4376 23.3335 45.3331V44.6664H40.6668Z"
        fill="#2364EB"
      />
      <path
        d="M3.35449 32.5977C3.49006 34.5005 4.29807 36.3067 6.20021 37.7333C8.38334 39.3707 12.2222 40.6667 18.6669 40.6667H19.3335V40C19.3335 38.8954 20.229 38 21.3335 38C22.4381 38 23.3335 38.8954 23.3335 40V40.6667H40.6669V40C40.6669 38.8954 41.5623 38 42.6669 38C43.7714 38 44.6669 38.8954 44.6669 40V40.6667H45.3335C51.7782 40.6667 55.6171 39.3707 57.8002 37.7333C59.7036 36.3058 60.5114 34.4981 60.6462 32.594C60.5962 29.3528 60.4267 27.2874 59.8513 25.5164C58.2027 20.4424 54.2246 16.4644 49.1506 14.8157C46.6401 14 43.538 14 37.3337 14H26.667C20.4628 14 17.3606 14 14.8501 14.8157C9.77612 16.4644 5.79806 20.4424 4.14942 25.5164C3.57377 27.2881 3.40435 29.3544 3.35449 32.5977Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6665 7.33203C25.1437 7.33203 20.6665 11.8092 20.6665 17.332C20.6665 18.4366 19.7711 19.332 18.6665 19.332C17.5619 19.332 16.6665 18.4366 16.6665 17.332C16.6665 9.60005 22.9345 3.33203 30.6665 3.33203H33.3332C41.0652 3.33203 47.3332 9.60005 47.3332 17.332C47.3332 18.4366 46.4377 19.332 45.3332 19.332C44.2286 19.332 43.3332 18.4366 43.3332 17.332C43.3332 11.8092 38.856 7.33203 33.3332 7.33203H30.6665Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5825_7748">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5825_7782)">
      <path
        opacity="0.4"
        d="M3.3335 30.6654C3.3335 45.7611 15.571 57.9987 30.6668 57.9987C45.7626 57.9987 58.0002 45.7611 58.0002 30.6654C58.0002 15.5696 45.7626 3.33203 30.6668 3.33203C15.571 3.33203 3.3335 15.5696 3.3335 30.6654Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.2523 47.9178C46.0333 47.1368 47.2997 47.1368 48.0807 47.9178L57.4141 57.2512C58.1951 58.0322 58.1951 59.2985 57.4141 60.0796C56.633 60.8606 55.3667 60.8606 54.5856 60.0796L45.2523 50.7462C44.4712 49.9652 44.4712 48.6989 45.2523 47.9178Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5825_7782">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MagicIcon = ({
  width = '64',
  height = '64',
  fill = '#2364eb',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5825_7755)">
      <path
        d="M63.323 26.0812C55.1303 24.1967 48.7656 17.0353 47.0729 7.91398C47.0052 7.46169 46.6667 7.16016 46.1927 7.16016C45.7864 7.16016 45.4479 7.46169 45.3125 7.91398C43.6198 17.0353 37.1874 24.1967 29.0623 26.0812C28.6561 26.1566 28.3853 26.5335 28.3853 27.0612C28.3853 27.5135 28.6561 27.8904 29.0623 28.0412C37.2551 29.9258 43.6198 37.0871 45.3125 46.1331C45.3802 46.5854 45.7187 46.8869 46.1927 46.8869C46.5989 46.8869 46.9375 46.5854 47.0729 46.1331C48.7656 37.0118 55.198 29.9258 63.323 28.0412C63.7293 27.9658 64.0001 27.5889 64.0001 27.0612C64.0001 26.5335 63.7293 26.1566 63.323 26.0812Z"
        fill={fill}
      />
      <path
        d="M36.0354 47.3406C29.4676 45.833 24.3218 40.1039 22.9676 32.7163C22.8999 32.3394 22.629 32.1133 22.2905 32.1133C21.9519 32.1133 21.6811 32.3394 21.6134 32.7163C20.2592 40.1039 15.1133 45.833 8.54558 47.3406C8.20703 47.416 8.00391 47.7175 8.00391 48.0944C8.00391 48.4714 8.20703 48.7729 8.54558 48.8483C15.1133 50.3559 20.2592 56.085 21.6134 63.3972C21.6811 63.7741 21.9519 64.0002 22.2905 64.0002C22.629 64.0002 22.8999 63.7741 22.9676 63.3972C24.3218 56.085 29.4676 50.3559 36.0354 48.8483C36.3739 48.7729 36.5771 48.4714 36.5771 48.0944C36.5771 47.7175 36.3739 47.416 36.0354 47.3406Z"
        fill={fill}
        fillOpacity="0.4"
      />
      <path
        d="M12.6761 30.0777C12.8115 30.53 13.15 30.8316 13.5563 30.8316C13.9625 30.8316 14.3688 30.53 14.4365 30.0777C15.8584 23.3687 20.7334 18.0165 26.6918 16.4335C27.0981 16.2827 27.3689 15.9058 27.3689 15.4535C27.3689 15.0012 27.0981 14.5489 26.6918 14.4735C20.598 12.8151 15.8584 7.53828 14.4365 0.753829C14.3688 0.301532 13.9625 0 13.5563 0C13.15 0 12.7438 0.301532 12.6761 0.753829C11.1865 7.53828 6.51454 12.8151 0.420741 14.4735C0.014488 14.6243 -0.256348 15.0012 -0.256348 15.4535C-0.256348 15.9058 0.014488 16.3581 0.420741 16.4335C6.37913 18.0165 11.1865 23.3687 12.6761 30.0777Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_5825_7755">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5838_2840)">
      <path
        opacity="0.4"
        d="M3.33301 31.9987C3.33301 47.8309 16.1675 60.6654 31.9997 60.6654C47.8318 60.6654 60.6663 47.8309 60.6663 31.9987C60.6663 16.1665 47.8318 3.33203 31.9997 3.33203C16.1675 3.33203 3.33301 16.1665 3.33301 31.9987Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 20.668C33.1046 20.668 34 21.5634 34 22.668V29.672C34 32.2441 35.1425 34.6833 37.1184 36.3299L41.2804 39.7982C42.1289 40.5053 42.2436 41.7665 41.5364 42.615C40.8293 43.4636 39.5682 43.5782 38.7196 42.8711L34.5577 39.4028C31.6698 36.9962 30 33.4312 30 29.672V22.668C30 21.5634 30.8954 20.668 32 20.668Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5838_2840">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5838_2866)">
      <path
        opacity="0.4"
        d="M8.66699 18.6654C8.66699 10.197 15.532 3.33203 24.0003 3.33203H32.1054C35.7766 3.33203 39.3008 4.774 41.919 7.34732L51.1472 16.4173C53.8252 19.0495 55.3337 22.6471 55.3337 26.4021V45.332C55.3337 53.8004 48.4687 60.6654 40.0003 60.6654H24.0003C15.532 60.6654 8.66699 53.8004 8.66699 45.332V18.6654Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 14C33.1046 14 34 14.8954 34 16V18.6667C34 21.9804 36.6863 24.6667 40 24.6667H42.6667C43.7712 24.6667 44.6667 25.5621 44.6667 26.6667C44.6667 27.7712 43.7712 28.6667 42.6667 28.6667H40C34.4772 28.6667 30 24.1895 30 18.6667V16C30 14.8954 30.8954 14 32 14Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5838_2866">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SiteMapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5850_3024)">
      <path
        d="M46 53.3333C46 57.3834 49.2832 60.6667 53.3333 60.6667C57.3834 60.6667 60.6667 57.3834 60.6667 53.3333C60.6667 49.2832 57.3834 46 53.3333 46C49.2832 46 46 49.2832 46 53.3333Z"
        fill="#2364EB"
      />
      <path
        d="M3.33301 53.3333C3.33301 57.3834 6.61625 60.6667 10.6663 60.6667C14.7164 60.6667 17.9997 57.3834 17.9997 53.3333C17.9997 49.2832 14.7164 46 10.6663 46C6.61625 46 3.33301 49.2832 3.33301 53.3333Z"
        fill="#2364EB"
      />
      <path
        d="M24.667 53.3333C24.667 57.3834 27.9502 60.6667 32.0003 60.6667C36.0504 60.6667 39.3337 57.3834 39.3337 53.3333C39.3337 49.2832 36.0504 46 32.0003 46C27.9502 46 24.667 49.2832 24.667 53.3333Z"
        fill="#2364EB"
      />
      <path
        d="M37.333 17.9987H26.6663C22.6163 17.9987 19.333 14.7155 19.333 10.6654C19.333 6.61528 22.6163 3.33203 26.6663 3.33203H37.333C41.3831 3.33203 44.6663 6.61528 44.6663 10.6654C44.6663 14.7155 41.3831 17.9987 37.333 17.9987Z"
        fill="#2364EB"
      />
      <path
        opacity="0.4"
        d="M34.0003 50.6667C34.0003 51.7712 33.1049 52.6667 32.0003 52.6667C30.8958 52.6667 30.0003 51.7712 30.0003 50.6667V31.3333H21.3337C16.5472 31.3333 12.667 35.2135 12.667 40V50.6667C12.667 51.7712 11.7716 52.6667 10.667 52.6667C9.56242 52.6667 8.66699 51.7712 8.66699 50.6667V40C8.66699 33.0044 14.3381 27.3333 21.3337 27.3333H30.0003V16C30.0003 14.8954 30.8958 14 32.0003 14C33.1049 14 34.0003 14.8954 34.0003 16V27.3333H42.667C49.6626 27.3333 55.3337 33.0044 55.3337 40V50.6667C55.3337 51.7712 54.4382 52.6667 53.3337 52.6667C52.2291 52.6667 51.3337 51.7712 51.3337 50.6667V40C51.3337 35.2135 47.4535 31.3333 42.667 31.3333H34.0003V50.6667Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5850_3024">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5850_2971)">
      <path
        opacity="0.4"
        d="M3.33301 31.9987C3.33301 47.8309 16.1675 60.6654 31.9997 60.6654C47.8318 60.6654 60.6663 47.8309 60.6663 31.9987C60.6663 16.1665 47.8318 3.33203 31.9997 3.33203C16.1675 3.33203 3.33301 16.1665 3.33301 31.9987Z"
        fill="#2364EB"
      />
      <path
        d="M22 32C22 26.4772 26.4772 22 32 22C37.5228 22 42 26.4772 42 32C42 37.5228 37.5228 42 32 42C26.4772 42 22 37.5228 22 32Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.1464 18.6547C46.8894 19.472 46.8291 20.7369 46.0118 21.4799L40.1452 26.8132C39.3278 27.5562 38.063 27.496 37.3199 26.6787C36.5769 25.8614 36.6372 24.5965 37.4545 23.8535L43.3211 18.5201C44.1385 17.7771 45.4034 17.8374 46.1464 18.6547Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6667 34.668C13.1939 34.668 12 33.4741 12 32.0013L12 31.9986C12 30.5259 13.1939 29.332 14.6667 29.332C16.1394 29.332 17.3333 30.5259 17.3333 31.9986L17.3333 32.0013C17.3333 33.4741 16.1394 34.668 14.6667 34.668Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3337 46.668C17.8609 46.668 16.667 45.4741 16.667 44.0013L16.667 43.9986C16.667 42.5259 17.8609 41.332 19.3337 41.332C20.8064 41.332 22.0003 42.5259 22.0003 43.9986L22.0003 44.0013C22.0003 45.4741 20.8064 46.668 19.3337 46.668Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.6667 46.668C43.1939 46.668 42 45.4741 42 44.0013L42 43.9986C42 42.5259 43.1939 41.332 44.6667 41.332C46.1394 41.332 47.3333 42.5259 47.3333 43.9986L47.3333 44.0013C47.3333 45.4741 46.1394 46.668 44.6667 46.668Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.3337 34.668C47.8609 34.668 46.667 33.4741 46.667 32.0013L46.667 31.9986C46.667 30.5259 47.8609 29.332 49.3337 29.332C50.8064 29.332 52.0003 30.5259 52.0003 31.9986L52.0003 32.0013C52.0003 33.4741 50.8064 34.668 49.3337 34.668Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9997 17.3359C30.5269 17.3359 29.333 16.142 29.333 14.6693L29.333 14.6666C29.333 13.1938 30.5269 11.9999 31.9997 11.9999C33.4724 11.9999 34.6663 13.1938 34.6663 14.6666L34.6663 14.6693C34.6663 16.142 33.4724 17.3359 31.9997 17.3359Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9997 52C30.5269 52 29.333 50.8061 29.333 49.3333L29.333 49.3307C29.333 47.8579 30.5269 46.664 31.9997 46.664C33.4724 46.664 34.6663 47.8579 34.6663 49.3307L34.6663 49.3333C34.6663 50.8061 33.4724 52 31.9997 52Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3337 22.668C17.8609 22.668 16.667 21.4741 16.667 20.0013L16.667 19.9986C16.667 18.5259 17.8609 17.332 19.3337 17.332C20.8064 17.332 22.0003 18.5259 22.0003 19.9986L22.0003 20.0013C22.0003 21.4741 20.8064 22.668 19.3337 22.668Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5850_2971">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5858_1446)">
      <path
        d="M32 0C14.328 0 0 14.328 0 32C0 49.672 14.328 64 32 64C49.672 64 64 49.672 64 32C64 14.328 49.672 0 32 0ZM26.6667 42.6667H21.3333V26.6667H26.6667V42.6667ZM24 24.2907C22.3813 24.2907 21.0667 22.968 21.0667 21.3333C21.0667 19.7013 22.3787 18.376 24 18.376C25.6213 18.376 26.9333 19.7013 26.9333 21.3333C26.9333 22.968 25.6187 24.2907 24 24.2907ZM45.3333 42.6667H40.0053V35.0373C40.0053 30.0213 34.6667 30.4453 34.6667 35.0373V42.6667H29.3333V34.6667V26.6667H34.6667V29.5813C36.992 25.272 45.3333 24.952 45.3333 33.7093V42.6667Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5858_1446">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArcheryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5858_1436)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66699 26.6654C8.66699 39.552 19.1137 49.9987 32.0003 49.9987C44.887 49.9987 55.3337 39.552 55.3337 26.6654C55.3337 13.7787 44.887 3.33203 32.0003 3.33203C19.1137 3.33203 8.66699 13.7787 8.66699 26.6654ZM14.0003 26.6654C14.0003 16.7242 22.0592 8.66536 32.0003 8.66536C41.9414 8.66536 50.0003 16.7242 50.0003 26.6654C50.0003 36.6065 41.9414 44.6654 32.0003 44.6654C22.0592 44.6654 14.0003 36.6065 14.0003 26.6654Z"
        fill="#2364EB"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 12.668C24.268 12.668 18 18.936 18 26.668C18 34.4 24.268 40.668 32 40.668C39.732 40.668 46 34.4 46 26.668C46 18.936 39.732 12.668 32 12.668ZM32 19.3346C27.9499 19.3346 24.6667 22.6179 24.6667 26.668C24.6667 30.7181 27.9499 34.0013 32 34.0013C36.0501 34.0013 39.3333 30.7181 39.3333 26.668C39.3333 22.6179 36.0501 19.3346 32 19.3346Z"
        fill="#2364EB"
      />
      <path
        d="M28.667 26.6654C28.667 24.8244 30.1594 23.332 32.0003 23.332C33.8413 23.332 35.3337 24.8244 35.3337 26.6654C35.3337 28.5063 33.8413 29.9987 32.0003 29.9987C30.1594 29.9987 28.667 28.5063 28.667 26.6654Z"
        fill="#2364EB"
      />
      <path
        opacity="0.32"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0293 43.6173C25.9765 44.1856 26.2836 45.4142 25.7153 46.3613L17.7153 59.6947C17.147 60.6418 15.9185 60.9489 14.9713 60.3806C14.0242 59.8124 13.717 58.5838 14.2853 57.6367L22.2853 44.3033C22.8536 43.3562 24.0821 43.0491 25.0293 43.6173Z"
        fill="#2364EB"
      />
      <path
        opacity="0.32"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.9707 43.6173C38.0235 44.1856 37.7164 45.4142 38.2847 46.3613L46.2847 59.6947C46.853 60.6418 48.0815 60.9489 49.0287 60.3806C49.9758 59.8124 50.283 58.5838 49.7147 57.6367L41.7147 44.3033C41.1464 43.3562 39.9179 43.0491 38.9707 43.6173Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.667 56C16.667 54.8954 17.5624 54 18.667 54H45.3337C46.4382 54 47.3337 54.8954 47.3337 56C47.3337 57.1046 46.4382 58 45.3337 58H18.667C17.5624 58 16.667 57.1046 16.667 56Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5858_1436">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const VideoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_25545)">
      <path
        opacity="0.4"
        d="M1.25 12C1.25 9.20342 1.25 7.80514 1.72603 6.70919C2.30653 5.37275 3.37275 4.30653 4.70919 3.72603C5.80514 3.25 7.20342 3.25 10 3.25C12.7966 3.25 14.1949 3.25 15.2908 3.72603C16.6272 4.30653 17.6935 5.37275 18.274 6.70919C18.75 7.80514 18.75 9.20342 18.75 12C18.75 14.7966 18.75 16.1949 18.274 17.2908C17.6935 18.6272 16.6272 19.6935 15.2908 20.274C14.1949 20.75 12.7966 20.75 10 20.75C7.20342 20.75 5.80514 20.75 4.70919 20.274C3.37275 19.6935 2.30653 18.6272 1.72603 17.2908C1.25 16.1949 1.25 14.7966 1.25 12Z"
        fill="#2364eb"
      />
      <path
        d="M5.5 10C5.5 11.3807 6.61929 12.5 8 12.5C9.38071 12.5 10.5 11.3807 10.5 10C10.5 8.61929 9.38071 7.5 8 7.5C6.61929 7.5 5.5 8.61929 5.5 10Z"
        fill="#2364eb"
      />
      <path
        d="M20 16C21.4912 16.1095 22.75 15.0172 22.75 13.3811V10.6185C22.75 8.98241 21.4913 7.89019 20 7.99974C20 8.99974 20 10.1195 20 11.9998C20 13.8801 20 15 20 16Z"
        fill="#2364eb"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_25545">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CareerPathIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_21246_2053)">
      <g opacity="0.4">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H6C5.58579 12.75 5.25 12.4142 5.25 12Z"
          fill="#2364eb"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11.25C11.4142 11.25 11.75 11.5858 11.75 12V16C11.75 17.7949 13.2051 19.25 15 19.25H18.5C18.9142 19.25 19.25 19.5858 19.25 20C19.25 20.4142 18.9142 20.75 18.5 20.75H15C12.3766 20.75 10.25 18.6234 10.25 16V12C10.25 11.5858 10.5858 11.25 11 11.25Z"
          fill="#2364eb"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 12.75C11.4142 12.75 11.75 12.4142 11.75 12V8C11.75 6.20507 13.2051 4.75 15 4.75H18.5C18.9142 4.75 19.25 4.41421 19.25 4C19.25 3.58579 18.9142 3.25 18.5 3.25H15C12.3766 3.25 10.25 5.37665 10.25 8V12C10.25 12.4142 10.5858 12.75 11 12.75Z"
          fill="#2364eb"
        />
      </g>
      <path
        d="M17.25 12C17.25 13.5188 18.4812 14.75 20 14.75C21.5188 14.75 22.75 13.5188 22.75 12C22.75 10.4812 21.5188 9.25 20 9.25C18.4812 9.25 17.25 10.4812 17.25 12Z"
        fill="#2364eb"
      />
      <path
        d="M1.25 12C1.25 13.5188 2.48122 14.75 4 14.75C5.51878 14.75 6.75 13.5188 6.75 12C6.75 10.4812 5.51878 9.25 4 9.25C2.48122 9.25 1.25 10.4812 1.25 12Z"
        fill="#2364eb"
      />
      <path
        d="M17.25 4C17.25 5.51878 18.4812 6.75 20 6.75C21.5188 6.75 22.75 5.51878 22.75 4C22.75 2.48122 21.5188 1.25 20 1.25C18.4812 1.25 17.25 2.48122 17.25 4Z"
        fill="#2364eb"
      />
      <path
        d="M17.25 20C17.25 21.5188 18.4812 22.75 20 22.75C21.5188 22.75 22.75 21.5188 22.75 20C22.75 18.4812 21.5188 17.25 20 17.25C18.4812 17.25 17.25 18.4812 17.25 20Z"
        fill="#2364eb"
      />
    </g>
    <defs>
      <clipPath id="clip0_21246_2053">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DollarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12_32328)">
      <path
        opacity="0.4"
        d="M1.25 12C1.25 8.73923 1.25 7.10885 1.76492 5.8165C2.50185 3.96695 3.96695 2.50185 5.8165 1.76492C7.10885 1.25 8.73923 1.25 12 1.25C15.2608 1.25 16.8912 1.25 18.1835 1.76492C20.0331 2.50185 21.4982 3.96695 22.2351 5.8165C22.75 7.10885 22.75 8.73923 22.75 12C22.75 15.2608 22.75 16.8912 22.2351 18.1835C21.4982 20.0331 20.0331 21.4982 18.1835 22.2351C16.8912 22.75 15.2608 22.75 12 22.75C8.73923 22.75 7.10885 22.75 5.8165 22.2351C3.96695 21.4982 2.50185 20.0331 1.76492 18.1835C1.25 16.8912 1.25 15.2608 1.25 12Z"
        fill="#2364eb"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5423 6.27117C13.0388 6.11776 14.7948 6.80981 15.4103 8.62388C15.5434 9.01613 15.3333 9.442 14.941 9.57508C14.5487 9.70816 14.1229 9.49806 13.9898 9.10581C13.6553 8.11977 12.6862 7.66177 11.6953 7.76335C10.6998 7.86539 10 8.48081 10 9.38479C10 10.1884 10.409 10.6838 10.7224 10.8695L10.732 10.8752C11.0019 11.0407 11.1765 11.1182 11.3706 11.1717C11.493 11.2054 11.632 11.2322 11.8179 11.2584C11.9963 11.2774 12.1615 11.2962 12.317 11.3177C12.3248 11.3186 12.3946 11.3289 12.3946 11.3289C12.6036 11.3598 12.7952 11.3968 12.978 11.4472C13.3449 11.5483 13.6493 11.695 13.9975 11.9081C14.7621 12.3637 15.45 13.3468 15.45 14.6801C15.45 16.5962 13.8998 17.6408 12.4077 17.7938C10.9112 17.9472 9.15522 17.2551 8.53975 15.4411C8.40667 15.0488 8.61677 14.6229 9.00903 14.4899C9.40128 14.3568 9.82715 14.5669 9.96023 14.9591C10.2948 15.9452 11.2638 16.4032 12.2548 16.3016C13.2502 16.1995 13.95 15.5841 13.95 14.6801C13.95 13.8765 13.541 13.3811 13.2276 13.1955L13.218 13.1898C12.9481 13.0242 12.7735 12.9467 12.5795 12.8933C12.457 12.8595 12.318 12.8327 12.1321 12.8066C11.9537 12.7876 11.7885 12.7687 11.6331 12.7472C11.6214 12.746 11.5554 12.7361 11.5554 12.7361C11.3464 12.7051 11.1548 12.6681 10.972 12.6178C10.6051 12.5166 10.3007 12.3699 9.95256 12.1569C9.18795 11.7012 8.50004 10.7181 8.50004 9.38479C8.50004 7.46874 10.0502 6.42412 11.5423 6.27117Z"
        fill="#2364eb"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.75C12.4142 16.75 12.75 17.0858 12.75 17.5V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V17.5C11.25 17.0858 11.5858 16.75 12 16.75Z"
        fill="#2364eb"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V6.5C12.75 6.91421 12.4142 7.25 12 7.25C11.5858 7.25 11.25 6.91421 11.25 6.5V6C11.25 5.58579 11.5858 5.25 12 5.25Z"
        fill="#2364eb"
      />
    </g>
    <defs>
      <clipPath id="clip0_12_32328">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
